import React, { forwardRef } from "react";
import "./GlobalFeedback.css";

const GlobalFeedback = forwardRef(function GlobalFeedback(
  { type = "success", text, role = "status", ariaLive = "polite", className = "" },
  ref
) {
  if (!text) return null;
  return (
    <p
      ref={ref}
      className={`gfb-feedback gfb-feedback--${type} ${className}`.trim()}
      role={role}
      aria-live={ariaLive}
    >
      {text}
    </p>
  );
});

export default GlobalFeedback;

